export default __webpack_public_path__ + "static/media/stato_occupazionale.ab2773bc.less";